const state = {
//text = affiche le texte directement
//lng = utilise le fichier de langue

    combo:{
        cboArrondi:[
            {lng: 'cfg_TempsReel', id: 0},
            {lng: 'cfg_1Min', id: 1},
            {lng: 'cfg_5Min', id: 2},
            {lng: 'cfg_15Min', id: 3},
            {lng: 'cfg_30Min', id: 4}
        ],
        cboComPort:[
            {text: 'COM 1', id: 'COM1'},
            {text: 'COM 2', id: 'COM2'},
            {text: 'COM 3', id: 'COM3'},
            {text: 'COM 4', id: 'COM4'},
            {text: 'COM 5', id: 'COM5'},
            {text: 'COM 6', id: 'COM6'},
            {text: 'COM 7', id: 'COM7'},
            {text: 'COM 8', id: 'COM8'},
            {text: 'COM 9', id: 'COM9'},
            {text: 'COM 10', id: 'COM10'},
            {text: 'COM 11', id: 'COM11'},
            {text: 'COM 12', id: 'COM12'},
            {text: 'COM 13', id: 'COM13'},
            {text: 'COM 14', id: 'COM14'},
            {text: 'COM 15', id: 'COM15'}
        ],
        cboComSpeed:[
            {text: '2400', id: 2400},
            {text: '4800', id: 4800},
            {text: '7200', id: 7200},
            {text: '9600', id: 9600},
            {text: '14400', id: 14400},
            {text: '19200', id: 19200},
            {text: '38400', id: 38400},
            {text: '57600', id: 57600},
            {text: '115200', id: 115200},
            {text: '128000', id: 128000}
        ],
        cboLabelPrinter:[
            {lng: 'g_Aucun', id: 0},
            {text: 'Zebra - ZD410', id: 1},
        ],
        cboTypeDeCommerce:[
            {lng: 'cfg_TypeGeneral', id: 0},
            {lng: 'cfg_TypeVetement', id: 1},
            {lng: 'cfg_TypeCigarette', id: 2},
        ],
        cboNiveauPrix:[
            {lng: 'g_Aucun', id: 0},
            {lng: 'cc_Prix1', id: 1},
            {lng: 'cc_Prix2', id: 2},
            {lng: 'cc_Prix3', id: 3},
            {lng: 'cc_Prix4', id: 4},
            {lng: 'cc_Coutant', id: 5},
        ],
        cboAccountType:[
            {lng: 'acc_Bank', id: 0}, //Banque
            {lng: 'acc_Assets', id: 1}, //Actif
            {lng: 'acc_Liabilities', id: 2}, //Passif
            {lng: 'acc_Capital', id: 3}, //Capitaux
            {lng: 'acc_Income', id: 4}, //Revenus
            {lng: 'acc_Expenses', id: 5}, //Dépense
            {lng: 'acc_Allocation', id: 6}, //Multiple
            {lng: 'acc_Quantiry', id: 7} //Quantité
        ]


    }
}
const getters = {
    getCombo: () => {
        return state.combo
    }
}
const mutations = {

}
const actions = {
}

export default{
    state,
    mutations,
    getters,
    actions
}